import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMail = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M1.33398 7.99996C1.33398 5.4858 1.33398 4.22872 2.11503 3.44767C2.89608 2.66663 4.15316 2.66663 6.66732 2.66663H9.33398C11.8481 2.66663 13.1052 2.66663 13.8863 3.44767C14.6673 4.22872 14.6673 5.4858 14.6673 7.99996C14.6673 10.5141 14.6673 11.7712 13.8863 12.5522C13.1052 13.3333 11.8481 13.3333 9.33398 13.3333H6.66732C4.15316 13.3333 2.89608 13.3333 2.11503 12.5522C1.33398 11.7712 1.33398 10.5141 1.33398 7.99996Z",
			stroke: "#585863"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 5.33337L5.43926 6.53276C6.66369 7.55311 7.2759 8.06329 8 8.06329C8.7241 8.06329 9.33631 7.55311 10.5607 6.53276L12 5.33337",
			stroke: "#585863",
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgMail);
export { ForwardRef as ReactComponent };
